// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FVIc","right":"styles_right__1NrBh"};